module.exports = __webpack_public_path__ + "img/tool-second-section_1000.3d7163b8.png";